export default __webpack_public_path__ + "static/partnerColorIcon18-0d80466d6d9632a37be63962abc29790.svg";